import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'reactstrap';
import { IDisplayBoardState } from '../../../../models/displayboardModel';
import * as _ from 'lodash';
import { interval } from 'rxjs';
import { getIntervalTokensFlip } from '../../../../helpers/helpersIndex'
import { EStatusEnum } from '../../../../models/utilitiesModel';

let subscribe;
const ThemeOneParentManager: React.FC = () => {
    const { t } = useTranslation("translations");
    const [chunkIndex, setChunkIndex] = useState(0);
    const tokensDataOrg = useSelector((state: any) => {
        if (state && state.displayBoardReducer && state.displayBoardReducer.tokensData)
            return (state.displayBoardReducer as IDisplayBoardState).tokensData;
        else return [];
    });
    const isDisplayBoardLicenseActive: boolean = useSelector((state: any) => state.displayBoardReducer?.isLicenseActive === EStatusEnum.NACTIVE)
    const isDisplayBoardActive: boolean = useSelector((state: any) => state.displayBoardReducer?.isDisplayBoardActive === EStatusEnum.NACTIVE)
    const tokensData = (isDisplayBoardLicenseActive && isDisplayBoardActive) ? tokensDataOrg : []
    const chunkTokensData = _.chunk(_.chunk(tokensData, 2), 4);
    const selectedChunkTokensData = chunkTokensData.length ? chunkTokensData[chunkIndex] : [];
    useEffect(() => {
        subscribe = interval(1000 * getIntervalTokensFlip()).subscribe(() => {
            if (chunkTokensData.length > 1) {
                let index = chunkIndex;
                index++;
                if (index >= chunkTokensData.length)
                    setChunkIndex(0);
                else setChunkIndex(index);
            }
            else {
                setChunkIndex(0);
            }
        });
        return () => {
            if (subscribe)
                subscribe.unsubscribe();
        }
    });

    return (
        <>
            <Row className="mdbBody">
                <Col>
                    <Row>
                        <Col className="mLeftcolumn">
                            <div className="mcolHeader">
                                <div className='mlefttablerow'>
                                    <div className="text_arabic">{t('DisplayBoard.tokenNumberArb')}</div>
                                    <div>{t('DisplayBoard.tokenNumber')}</div>
                                </div>
                                <div className='mlefttablerow'>
                                    <div className="text_arabic">{t('DisplayBoard.counterNumberArb')}</div>
                                    <div>{t('DisplayBoard.counterNumber')}</div>
                                </div>
                            </div>
                            <div className="mcolHeader">
                                <div className='mlefttablerow'>
                                    <div className="text_arabic">{t('DisplayBoard.tokenNumberArb')}</div>
                                    <div>{t('DisplayBoard.tokenNumber')}</div>
                                </div>
                                <div className='mlefttablerow'>
                                    <div className="text_arabic">{t('DisplayBoard.counterNumberArb')}</div>
                                    <div>{t('DisplayBoard.counterNumber')}</div>
                                </div>
                            </div>
                            <div className="mcolHeader">
                                <div className='mlefttablerow'>
                                    <div className="text_arabic">{t('DisplayBoard.tokenNumberArb')}</div>
                                    <div>{t('DisplayBoard.tokenNumber')}</div>
                                </div>
                                <div className='mlefttablerow'>
                                    <div className="text_arabic">{t('DisplayBoard.counterNumberArb')}</div>
                                    <div>{t('DisplayBoard.counterNumber')}</div>
                                </div>
                            </div>
                            <div className="mcolHeader">
                                <div className='mlefttablerow'>
                                    <div className="text_arabic">{t('DisplayBoard.tokenNumberArb')}</div>
                                    <div>{t('DisplayBoard.tokenNumber')}</div>
                                </div>
                                <div className='mlefttablerow'>
                                    <div className="text_arabic">{t('DisplayBoard.counterNumberArb')}</div>
                                    <div>{t('DisplayBoard.counterNumber')}</div>
                                </div>
                            </div>
                        </Col>
                        <Col className="mRightContainer">
                            {isDisplayBoardActive && isDisplayBoardLicenseActive && <>
                                <div className="mRightcolumn">
                                    {selectedChunkTokensData?.length >= 1 && selectedChunkTokensData[0].map(token => (
                                        <div key={token.tokenId}>
                                            <div className="mtoken">
                                                <div className='mtablerow'>
                                                    <span>{token.tokenNo}</span>
                                                </div>
                                                <div className='mtablerow'>
                                                    <span>{token.roomNo}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className="mRightcolumn">
                                    {selectedChunkTokensData?.length >= 2 && selectedChunkTokensData[1].map(token => (
                                        <div key={token.tokenId}>
                                            <div className="mtoken">
                                                <div className='mtablerow'>
                                                    <span>{token.tokenNo}</span>
                                                </div>
                                                <div className='mtablerow'>
                                                    <span>{token.roomNo}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className="mRightcolumn">
                                    {selectedChunkTokensData?.length >= 3 && selectedChunkTokensData[2].map(token => (
                                        <div key={token.tokenId}>
                                            <div className="mtoken">
                                                <div className='mtablerow'>
                                                    <span>{token.tokenNo}</span>
                                                </div>
                                                <div className='mtablerow'>
                                                    <span>{token.roomNo}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className="mRightcolumn">
                                    {selectedChunkTokensData?.length >= 4 && selectedChunkTokensData[3].map(token => (
                                        <div key={token.tokenId}>
                                            <div className="mtoken">
                                                <div className='mtablerow'>
                                                    <span>{token.tokenNo}</span>
                                                </div>
                                                <div className='mtablerow'>
                                                    <span>{token.roomNo}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>
                            }
                            {!isDisplayBoardLicenseActive && <div className='w100 flex-center'>
                                <h1 className="text_arabic" style={{ color: '#ffffff' }}>{t('DisplayBoard.licenseExpiryMessageArb')}</h1>
                                <h1 style={{ color: '#ffffff' }}>{t('DisplayBoard.licenseExpiryMessage')}</h1>
                            </div>
                            }
                            {!isDisplayBoardActive && <div className='w100 flex-center'>
                                <h1 className="text_arabic" style={{ color: '#ffffff' }}>{t('DisplayBoard.DisplayBoardInactiveMessageArb')}</h1>
                                <h1 style={{ color: '#ffffff' }}>{t('DisplayBoard.DisplayBoardInactiveMessage')}</h1>
                            </div>}
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    )
}
export default React.memo(ThemeOneParentManager);